package org.teddapp.project.parcours

/**
 * Sélecteur de fichier branché par la plateforme au démarrage : rend le texte du
 * fichier choisi, ou null si l'utilisateur a annulé. Sans sélecteur (Android, iOS
 * pour l'instant), l'écran propose de coller le JSON à la place.
 */
object ParcoursFilePicker {
    var pick: (suspend () -> String?)? = null
}
